import type { CotizacionAutosDetalle, QuoteData } from '@/types/quote.types';
import { executeForCRUD } from '../frontBack';
import { getWidgetAgentData, getWidgetSellerIdentity } from '@/utils/widgetAgent';
import { buildDetalleParams } from './detalleParams';

const ensureCotizacionIds = (cotizacion: CotizacionAutosDetalle): CotizacionAutosDetalle => {
  if (!cotizacion.Id_Cotizacion && !cotizacion.Id_Cotizacion_Autos_Detalle) {
    console.error('La respuesta no incluye Id_Cotizacion ni Id_Cotizacion_Autos_Detalle');
    throw new Error(
      'No se pudo obtener el ID de la cotización generada. Verifica que la cotización se haya creado correctamente.'
    );
  }

  // CotizaTodas may need Id_Cotizacion_Autos_Detalle in place of Id_Cotizacion
  if (!cotizacion.Id_Cotizacion && cotizacion.Id_Cotizacion_Autos_Detalle) {
    cotizacion.Id_Cotizacion = cotizacion.Id_Cotizacion_Autos_Detalle;
  }
  return cotizacion;
};

/**
 * Genera o actualiza una cotización de autos detalle
 * @param quoteData Datos de la cotización desde el store
 * @param isUpdate Si es true, actualiza una cotización existente (requiere Id_Cotizacion_Autos_Detalle)
 * @returns Respuesta de la API con los datos de la cotización generada
 */
export const generateCotizacionAutosDetalle = async (
  quoteData: QuoteData,
  isUpdate = false
): Promise<CotizacionAutosDetalle> => {
  const params = buildDetalleParams({
    quoteData,
    isUpdate,
    agentData: getWidgetAgentData(),
    // The Insert SP resolves seller/agent by Guid_Vendedor, Id_Persona_Vendedor or Clave_Agente
    seller: isUpdate ? null : getWidgetSellerIdentity(),
  });

  const response = await executeForCRUD(params);

  if (response.success && Array.isArray(response.data) && response.data.length > 0) {
    return ensureCotizacionIds(response.data[0] as CotizacionAutosDetalle);
  }

  console.error('Error en generateCotizacionAutosDetalle:', response.errorMessage);
  throw new Error(response.errorMessage || 'Error al generar la cotización');
};
